import { Button, ScreenCard } from '@/shared/ui'

export function NotFoundPage() {
  return (
    <ScreenCard
      icon="search"
      title="Здесь ничего нет"
      hint="Такой страницы не существует. Возможно, ссылка устарела."
      action={
        <Button variant="accent" onClick={() => window.location.assign('/')}>
          На главную
        </Button>
      }
    />
  )
}
